import { Node } from "../node";

export class SwitchProviderNode extends Node {
  get defaults() {
    return {
      ...super.defaults,
      name: "SwitchProviderNode",

      providerGroupIds: [],
      targetNodeId: "continue",
    };
  }

  get context() {
    return { switchProviderGroupIds: this.providerGroupIds };
  }

  get possibleNextNodeIds() {
    return [this.targetNodeId];
  }

  autoAdvance() {
    return true;
  }

  nextNodeId() {
    return this.targetNodeId;
  }
}
